import { ArrowLeft, ArrowUpRight, Check, CreditCard, UsersRound } from "lucide-react";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Reveal from "@/components/Reveal";
import "@/App.css";

const SpecialOffersPage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute("content");
    document.title = "Exclusive Student Offers & Packages | MyEnglish Lesson.ca";
    description?.setAttribute("content", "Explore Student Offers from MyEnglish Lesson.ca, including Class Pass rewards and the 9-Class Private Acceleration Bundle.");
    return () => { document.title = previousTitle; if (description && previousDescription) description.setAttribute("content", previousDescription); };
  }, []);

  const goToBookings = () => { window.location.href = "/#booking-section"; };

  return (
    <div className="offers-page" id="special-offers-top">
      <Header homePrefix="/" onBook={goToBookings} />
      <main>
        <section className="offers-hero" aria-labelledby="offers-title">
          <div className="offers-shell">
            <Reveal className="offers-hero-copy">
              <a className="membership-back-link" href="/#top" data-testid="offers-back-home-link"><ArrowLeft size={15} /> Back to MyEnglish Lesson.ca</a>
              <div className="section-kicker">PRIVATE STUDENT OFFERS</div>
              <h1 id="offers-title">Exclusive Student Offers &amp; Packages</h1>
              <p>Choose between $32 Group Practice, $55 Private Lessons, and the $390/month private acceleration bundle.</p>
            </Reveal>
          </div>
        </section>
        <section className="offers-section section-space" aria-labelledby="offers-title">
          <Reveal className="offers-shell">
            <div className="offers-grid">
              <article className="offer-card offer-card-pass" data-testid="special-offer-class-pass-card">
                <div className="offer-card-topline"><span>01 · ATTENDANCE REWARD PROGRAM</span><CreditCard size={17} /></div>
                <h2>Class Pass</h2>
                <div className="offer-price"><strong>$20</strong><span>back / eligible class</span></div>
                <p className="offer-value">Earn $20 back on eligible $32 Group Practice or $55 Private Lessons.</p>
                <div className="offer-session-note">Standard rates: $32 Group Practice · $55 Private Lesson</div>
                <ul className="offer-feature-list">
                  <li><Check size={16} /> Up to 5 classes per month</li>
                  <li><Check size={16} /> Up to 60 classes per year</li>
                  <li><Check size={16} /> Not applicable to the 9-Class Private Pass Bundle</li>
                </ul>
                <a className="button button-crimson offer-cta" href="https://buy.stripe.com/fZucN5f6H2QW0d0fUfbAs00" target="_blank" rel="noopener noreferrer" data-testid="special-offer-class-pass-cta">Explore Class Pass <ArrowUpRight size={16} /></a>
              </article>
              <article className="offer-card offer-card-bundle" data-testid="special-offer-bundle-card">
                <div className="offer-card-topline"><span>02 · PRIVATE ACCELERATION</span><UsersRound size={17} /></div>
                <h2>9-Lesson Private Acceleration Bundle</h2>
                <div className="offer-price"><strong>$390</strong><span>/ month locked-in</span></div>
                <p className="offer-value">Maximum 1-on-1 immersion at $43.33 per lesson (Save over 21% off the standard $55 private rate).</p>
                <div className="bundle-breakdown">
                  <div><strong>9</strong><span>Private Lessons<br /><small>Full 1-on-1 coaching every month</small></span></div>
                </div>
                <ul className="offer-feature-list">
                  <li><Check size={16} /> 9 full 1-on-1 private lessons included</li>
                  <li><Check size={16} /> $390/month locked-in</li>
                  <li><Check size={16} /> Private-only acceleration with dedicated 1-on-1 coaching</li>
                </ul>
                <a className="button button-crimson offer-cta" href="https://buy.stripe.com/5kQbJ16Ab3V03pc7nJbAs01" target="_blank" rel="noopener noreferrer" data-testid="special-offer-bundle-cta">Secure Your Private Bundle <ArrowUpRight size={16} /></a>
              </article>
            </div>
          </Reveal>
        </section>
      </main>
      <Footer homePrefix="/" />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
};

export default SpecialOffersPage;
